// cohorts/list services
// Pure async functions only: no React, no hooks, no state. Parse at this boundary.
import { privateApi } from "@core/libs/axios";
import { parseWith } from "@core/parse";
import { CohortListSchema, type CohortList } from "../types";

/** The axios base URL carries `/api/v1`. */
const COHORTS_PATH = "/cohorts/";

/**
 * `GET /cohorts/`: the cohorts this account may see (the President all of them, an Administrator
 * only the ones they are responsible for), the counts, and the page-level `available_actions`.
 * Scope is applied by the server before counts and paging.
 */
export async function listCohorts(): Promise<CohortList> {
  const dto = await privateApi
    .get<unknown>(COHORTS_PATH, { params: { status: "all", page_size: 100 } })
    .then((r) => r.data);
  return parseWith(CohortListSchema, dto, `GET ${COHORTS_PATH}`);
}
